import React from 'react';
import styled, { css } from 'styled-components';
import { basicColor, radius } from '../../../styles/template';

interface Props {
    children: React.ReactNode
    className?: string
    accent?: boolean
    notCentered?: boolean
}

const Item = styled.div<Props>`
    width: 100%;
    background: ${props => props.theme.color.Item};
    
    ${({ accent }) => accent && css`
        background: ${basicColor.deepDark};
        & > * {
            color: ${basicColor.white};
        }
    `}
    
    border-radius: ${radius.large};
    position: relative;
    display: grid;
    grid-template-rows: auto;
    gap: 2rem;
    place-items: center;
    align-items: center;
    text-align: center;

    ${({ notCentered }) => notCentered && css`
        place-items: normal;
        align-items: normal;
        text-align: left;
    `}
    //justify-content: center;
    padding: 4rem;
    // box-shadow: ${props => props.theme.boxShadow.Middle};
`

const DesignSystemItem: React.FC<Props> = props => {
    const { children, accent, className } = props;
    return <Item className={className} {...props}>{children}</Item>
}

export default DesignSystemItem